export const CREATE_BOOKMARK_OPERATION_NAME = 'KnowledgeDiscoveryAdminhubCreateBookmarkMutation';
export const CreateBookmarkMutation: '\nmutation KnowledgeDiscoveryAdminhubCreateBookmarkMutation($cloudId: ID!, $keyPhrases: [String!], $url: String!, $title: String!, $description: String, $orgId: String!) {\n\tknowledgeDiscovery {\n\t  createBookmark(\n\t\tinput: {cloudId: $cloudId, keyPhrases: $keyPhrases, url: $url, title: $title, description: $description, orgId: $orgId}\n\t  ) @optIn(to: "KnowledgeDiscovery Create bookmarks in AdminHub") {\n\t\t... on KnowledgeDiscoveryCreateAdminhubBookmarkPayload {\n\t\t  success\n\t\t  errors {\n\t\t\tmessage\n\t\t\textensions {\n\t\t\t  ... on KnowledgeDiscoveryBookmarkMutationErrorExtension {\n\t\t\t\tbookmarkFailureMetadata {\n\t\t\t\t  errorType\n\t\t\t\t  ... on KnowledgeDiscoveryBookmarkCollisionFailureMetadata {\n\t\t\t\t\tkeyPhrase\n\t\t\t\t  }\n\t\t\t\t  ... on KnowledgeDiscoveryBookmarkValidationFailureMetadata {\n\t\t\t\t\tkeyPhrase\n\t\t\t\t  }\n\t\t\t\t}\n\t\t\t  }\n\t\t\t}\n\t\t  }\n\t\t}\n\t  }\n\t}\n}\n' = `
mutation ${CREATE_BOOKMARK_OPERATION_NAME}($cloudId: ID!, $keyPhrases: [String!], $url: String!, $title: String!, $description: String, $orgId: String!) {
	knowledgeDiscovery {
	  createBookmark(
		input: {cloudId: $cloudId, keyPhrases: $keyPhrases, url: $url, title: $title, description: $description, orgId: $orgId}
	  ) @optIn(to: "KnowledgeDiscovery Create bookmarks in AdminHub") {
		... on KnowledgeDiscoveryCreateAdminhubBookmarkPayload {
		  success
		  errors {
			message
			extensions {
			  ... on KnowledgeDiscoveryBookmarkMutationErrorExtension {
				bookmarkFailureMetadata {
				  errorType
				  ... on KnowledgeDiscoveryBookmarkCollisionFailureMetadata {
					keyPhrase
				  }
				  ... on KnowledgeDiscoveryBookmarkValidationFailureMetadata {
					keyPhrase
				  }
				}
			  }
			}
		  }
		}
	  }
	}
}
`;
